import { RefObject } from 'react';
import { clsx } from '../functions'
import { inputOnKeyUp } from "../functions.ts";
import './measure.css'
import { useStore } from '../state/state.ts';

function __(label: string): string{
  const m = {
    "Gas-Konstanttemperaturkessel" : <><span>Gas-Konstant-</span><br/><span>temperaturkessel</span></>,
    "Öl-Konstanttemperaturkessel" : <><span>Öl-Konstant-</span><br/><span>temperaturkessel</span></>,
    "Gas-Niedertemperaturkessel" : <><span>Gas-Nieder-</span><br/><span>temperaturkessel</span></>,
    "Öl-Niedertemperaturkessel" : <><span>Öl-Nieder-</span><br/><span>temperaturkessel</span></>,
    "Brennstoffzellenheizung" : <><span>Brennstoffzellen-</span><br/><span>heizung</span></>,
    "PV 4 kWp (4 kWh Batteriespeicher)" : <><span>PV 4 kWp-</span><br/><span>(4 kWh Batteriespeicher)</span></>,
    "PV 6 kWp (6 kWh Batteriespeicher)" : <><span>PV 6 kWp-</span><br/><span>(6 kWh Batteriespeicher)</span></>,
    "PV 8 kWp (8 kWh Batteriespeicher)" : <><span>PV 8 kWp-</span><br/><span>(8 kWh Batteriespeicher)</span></>,
    "PV 10 kWp (10 kWh Batteriespeicher)" : <><span>PV 10 kWp-</span><br/><span>(10 kWh Batteriespeicher)</span></>

    
  };
  return m[label] || label;
}

export default function Measure(props:{measure_ref: RefObject<HTMLButtonElement>, id: String, label: string, now?: string, future?: string, onClick: () => void}) {   
  const selected_menu_item = useStore((state) => state.selected_menu_item);
  const future = props.future && props.future.trim();
  const selected = selected_menu_item == props.id;

  return (
     <button 
        ref={props.measure_ref}
        className={'measure' + (selected ? ' measure--selected' : '')}
        tabIndex={0} 
        aria-label={props.label}
        aria-description={
          `Wert aktuell: ${props.now || "nicht definiert"}, Wert nach Sanierung: ${props.future || "nicht definiert"}`
        }
        onClick={props.onClick}
        onKeyUp={(event)=>inputOnKeyUp(event, ()=>{
          props.onClick();
          // setTimeout(() => {
          //   document.querySelector(".modal [tabindex]").focus();
          // }, 100); 
        })}
      >
      <div aria-hidden className='measure__label'>{props.label}</div>
      {(props.now || props.future) && <div aria-hidden className='measure__infos'>
        <div aria-hidden className={clsx('measure__info-now', !future && 'measure__info-now--single')}>{props.now ? __(props.now) : "unsaniert"}</div>
        {
          future && <>
            <div aria-hidden className='measure__info-triangle'></div>
            <div aria-hidden className='measure__info-future'>{__(props.future)}</div>
          </>   
        }
      </div>}
     </button>
  )
}